
import { Box } from "@mui/material";

interface NoDataPlaceholderProps {
  icon?: string;
  text: string;
}

const NoDataPlaceholder = ({ icon = "content_paste_search", text }: NoDataPlaceholderProps) => {
  return (
    <Box sx={{ textAlign: "center", padding: "30px" }}>
      <span
        className="material-icons-outlined"
        style={{ fontSize: "100px", color: "gray" }}
      >
        {icon}
      </span>
      <Box sx={{ fontSize: "16px", margin: "10px", color: "gray" }}>
        {text}
      </Box>
    </Box>
  );
};

export default NoDataPlaceholder;